import React from 'react';
import { Link } from 'react-router-dom';

export class ShopByPriceReduction extends React.Component {
  getManualCmSp(buttonLink, pageFacet, buttonLabel) {
    let pageType = '';
    if ('backInStock' === pageFacet) {
      pageType = 'BackInStock';
    } else if ('reductions' === pageFacet) {
      pageType = 'PriceReduction';
    } else if ('limited' === pageFacet) {
      pageType = 'LimitedAvailability';
    } else if ('chance' === pageFacet) {
      pageType = 'LastChance65';
    } else if ('percent' === pageFacet) {
      const percentageOff =
        buttonLink.split('clearance-').length > 1 && buttonLink.split('clearance-')[1].split('/').length > 0
          ? buttonLink.split('clearance-')[1].split('/')[0]
          : '';
      pageType = percentageOff.concat('PercentOff');
    }
    if ('Womens/Juniors' === buttonLabel) {
      buttonLabel = 'Womens+Juniors';
    }
    return pageType.concat('-_-').concat(buttonLabel).concat('-_-button');
  }
  render() {
    var widgetData = this.props.widgetData;
    return (
      <div className='ShopByPriceReduction col-sm-12' id='ShopByPriceReduction'>
        <div className='row categories'>
          {widgetData.buttons.map((thisButton, index) => (
            <div className='col-sm-6 col-md-6 col-lg-3' key={index}>
              <Link
                to={thisButton.buttonLink}
                manual_cm_sp={this.getManualCmSp(
                  thisButton?.buttonLink ? thisButton.buttonLink : '',
                  widgetData?.pageFacet ? widgetData.pageFacet : '',
                  thisButton?.buttonLabel ? thisButton.buttonLabel : ''
                )}
              >
                <div className='category-wrapper'>
                  <div className='category-name'>{thisButton.buttonLabel}</div>
                  <div className='category-results'>
                    Shop All {thisButton.buttonCount} results
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25.39 48.77'>
                      <title>arrow-right</title>
                      <g data-name='Layer 2'>
                        <g data-name='Layer 1'>
                          <path d='M1,48.77a1,1,0,0,1-.71-1.71L23,24.39.29,1.71A1,1,0,0,1,1.71.29L25.09,23.68a1,1,0,0,1,0,1.41L1.71,48.48A1,1,0,0,1,1,48.77Z' />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ShopByPriceReduction;
